import partnerManagementData from '../../../data/partnerManagement/partnerManagementData.json';
import { toast } from 'react-hot-toast';

export const partnerData = partnerManagementData;

export const extractCoordinatesFromMapUrl = (url) => {
  if (!url) {
    toast.error('Please enter a Google Maps URL first');
    return null;
  }

  // Regex to match @lat,lng
  const atRegex = /@(-?\d+\.\d+),(-?\d+\.\d+)/;
  // Regex to match q=lat,lng
  const qRegex = /q=(-?\d+\.\d+),(-?\d+\.\d+)/;

  let lat = '';
  let lng = '';

  const atMatch = url.match(atRegex);
  if (atMatch) {
    lat = atMatch[1];
    lng = atMatch[2];
  } else {
    const qMatch = url.match(qRegex);
    if (qMatch) {
      lat = qMatch[1];
      lng = qMatch[2];
    }
  }

  if (lat && lng) {
    toast.success('Coordinates extracted!');
    return { latitude: lat, longitude: lng };
  } else {
    toast.error('Could not extract coordinates from this URL. Please enter them manually.');
    return null;
  }
};

export const exportPartnersToCSV = (partnersList) => {
  if (!partnersList || partnersList.length === 0) {
    toast.error('No partners to export');
    return;
  }

  const csvContent = [
    ['Business Name', 'Category', 'Location', 'Contact', 'Added On', 'Status'],
    ...partnersList.map((p) => [
      `"${p.business_name || ''}"`,
      p.category || '',
      `"${p.location_id?.name || p.city || 'N/A'}"`,
      p.phone_number || '',
      p.createdAt ? new Date(p.createdAt).toLocaleDateString('en-GB') : 'N/A',
      p.isActive === false ? 'Frozen' : 'Active'
    ])
  ]
    .map((e) => e.join(','))
    .join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', `partners_export_${new Date().toISOString().slice(0, 10)}.csv`);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  toast.success('Partners exported as CSV');
};

export { format24HourTime } from '../../../utils/formatters';
